import React from 'react';
import {TimeZone} from '../../../domain';
import {SingleSelect} from './base/SingleSelect';

function getOptionValue(option: TimeZone) {
  return option.Id.toString(10);
}

function getOptionLabel(option: TimeZone) {
  return option.UtcName;
}

type TimeZoneSelectProps = {
  options: readonly TimeZone[];
  value: TimeZone | null;
  onChange: (lessonType: TimeZone | null) => void;
  onBlur?: () => void;
};

export class TimeZoneSelect extends React.Component<TimeZoneSelectProps> {
  render() {
    const {value, options, onChange, onBlur} = this.props;
    return (
      <SingleSelect<TimeZone>
        options={options}
        value={value}
        getLabel={getOptionLabel}
        getValue={getOptionValue}
        onChange={onChange}
        onBlur={onBlur}/>);
  }
}
